import * as React from "react";
import {
  CodeSquareIcon,
  FactoryIcon,
  LineChart,
  Monitor,
  ShieldCheckIcon,
  SunDim,
  UploadIcon,
  User,
  Users2Icon,
} from "lucide-react";
import { SuperUserPermissionsEnum } from "@/client-admin";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
} from "@/components/ui/sidebar";
import { NavItem, NavMain } from "@/components/Sidebar/nav-main";
import { NavSettings } from "@/components/Sidebar/nav-settings";
import { NavUser } from "@/components/Sidebar/nav-user";
import { useAuth } from "@/hooks/useAuth";
import { checkSuperUserPermission } from "@/lib/utils";

export const ADMIN_PORTAL_NAV_ITEMS: NavItem[] = [
  {
    title: "Users",
    icon: User,
    url: "/admin/users",
    permission: "user-management",
  },
  {
    title: "Clients",
    icon: FactoryIcon,
    url: "/admin/clients",
    permission: "user-management",
  },
  {
    title: "User Client Links",
    icon: Users2Icon,
    url: "/admin/user-client-links",
    permission: "user-management",
  },
  {
    title: "Superusers",
    icon: ShieldCheckIcon,
    url: "/admin/superusers",
    permission: "superuser-management",
  },
  {
    title: "Price Update",
    icon: UploadIcon,
    url: `/admin/price-update`,
    permission: "price-update",
  },
  {
    title: "Auto Trader Monitoring",
    icon: Monitor,
    url: "/admin/auto-trader-monitoring",
    permission: "auto-trader",
  },
  {
    title: "Algo Trading",
    icon: CodeSquareIcon,
    url: "/admin/algo-trading",
    permission: "algo-trading",
  },
  {
    title: "Sparkspread",
    icon: LineChart,
    url: "/admin/sparkspread-dashboard",
    permission: "price-update",
  },
] as const;

function AdminAppBrand() {
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton size="lg">
          <div className="sidebar-primary text-sidebar-primary-foreground flex aspect-square size-8 items-center justify-center rounded-lg">
            <SunDim className="size-6" />
          </div>
          <div className="grid flex-1 text-left text-sm leading-tight">
            <span className="truncate font-semibold">BCI - Admin Portal</span>
          </div>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}

export function AdminAppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { user } = useAuth();
  const allowedNavItems = ADMIN_PORTAL_NAV_ITEMS.filter((item) => {
    try {
      checkSuperUserPermission(item.permission as SuperUserPermissionsEnum);
      return true;
    } catch {
      return false;
    }
  });

  return (
    <Sidebar collapsible="icon" {...props} variant="inset">
      <SidebarHeader>
        <AdminAppBrand />
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={allowedNavItems} />
        <NavSettings items={[]} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser
          user={{
            email: user?.email ?? "",
            name: `${user?.first_name ?? ""} ${user?.last_name ?? ""}`,
          }}
        />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
